import FlagIcon from 'vue-flag-icon'

export default ({ app, router, Vue }) => {
	Vue.use(FlagIcon)
}
